import {ConfigService} from './config.service';

export class ConfigServiceProvider{

  static configServiceProvider(configService: ConfigService) {
    return () => configService.load();
  }
}
